import { defineMessages } from 'react-intl';

import type { RefineListProps } from '@sorare/core/src/components/search/RefineList';
import { FILTERS } from '@sorare/core/src/lib/filters';
import { glossary } from '@sorare/core/src/lib/glossary';

import { makeFilter } from 'searchCards/RefineList';

const optionsForActiveFilters = defineMessages({
  crypto: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.crypto',
    defaultMessage: 'Crypto accepted',
  },
  cash: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.cash',
    defaultMessage: 'Cash accepted',
  },
});

export const getFormatSettlementWallets: (
  forActiveFilters: boolean
) => NonNullable<RefineListProps['formatOption']> = (
  forActiveFilters: boolean
) => {
  const formatSettlementWallets: NonNullable<
    RefineListProps['formatOption']
  > = (option, formatMessage) => {
    switch (option) {
      case 'eth':
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.crypto : glossary.crypto
        );
      case 'fiat':
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
      default:
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
    }
  };
  return formatSettlementWallets;
};

export const RefineSettlementWallets = makeFilter(FILTERS.settlementWallets, {
  searchable: false,
  formatOption: getFormatSettlementWallets(false),
  sortBy: ['name:desc'],
});
